// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1908z","badges":"styles_badges__190O2"};